import React from "react";
import Divider from "@mui/material/Divider";

const InsetVerticalDivider = (props) => (
  <Divider orientation="vertical" variant="inset" flexItem {...props} />
);

export default InsetVerticalDivider;
